import React, { useMemo } from "react"
import { useLocation } from "react-router-dom"

type BackgroundVariant = "auth" | "app"

interface BackgroundProps {
  className?: string
}

const BACKGROUND_CONFIG: Record<BackgroundVariant, string> = {
  auth: "bg-purple-900 md:bg-[url('/images/bg-entrance.svg')]",
  app: "bg-neutral-100 bg-[url('/images/bg-indoors.svg')]",
}

const BACKGROUND_CLASSES =
  "fixed inset-0 -z-10 w-full h-full pointer-events-none bg-no-repeat bg-cover bg-[position:100%_top] md:bg-center"

const getBackgroundVariant = (pathname: string): BackgroundVariant => {
  return pathname.startsWith("/signup") || pathname.startsWith("/login")
    ? "auth"
    : "app"
}

export const Background = React.memo(function Background({
  className,
}: BackgroundProps) {
  const location = useLocation()
  const pathname = location.pathname

  const variant = useMemo(() => getBackgroundVariant(pathname), [pathname])
  const backgroundClasses = BACKGROUND_CONFIG[variant]

  return (
    <div
      className={`${backgroundClasses} ${BACKGROUND_CLASSES} ${className}`}
      aria-hidden="true"
    />
  )
})
